import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=bc1003e6&"
import script from "./CustomerSummary.vue?vue&type=script&lang=js&"
export * from "./CustomerSummary.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSummary.vue?vue&type=style&index=0&id=bc1003e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports